import React from 'react'
import { FormattedMessage } from 'react-intl'

import IconArrowRight from '@/checkout-instore-legacy/components/Commons/Icons/ArrowRight'
import {
  SimpleList,
  SimpleListItem,
} from '@/checkout-instore-legacy/components/Commons/Elements/SimpleList'
import { mediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

interface RecentTermProps {
  recentTerms: {
    term: string
    productName: string
  }[]
  updateTerm: (term: string, skip: boolean) => void
}

export function RecentTerms({ recentTerms, updateTerm }: RecentTermProps) {
  const tablet = mediaQuery({
    phone: false,
    tablet: true,
    desktop: true,
  })
  const iconSize = tablet ? 28 : 16

  return (
    <section className="">
      <div className="flex mh4 mt5 mb5">
        <h2 className="flex-auto ma0 ml3-ns f6 f4-ns fw4 fw3-ns">
          <FormattedMessage id="recentSearches" />
        </h2>
      </div>

      <SimpleList>
        {recentTerms.map((searchTerm, i) => {
          const { term } = searchTerm

          return (
            <SimpleListItem
              icon={
                <IconArrowRight
                  width={iconSize}
                  height={iconSize}
                  color={'#DDDDDD'}
                />
              }
              key={`${i}-${term}`}
              onClick={() => {
                updateTerm(term, true)
              }}
            >
              <p className="f3-ns ma0 pv2 pv4-ns">
                <span id={`recentsearchlistitem-${i}`} className="underline">
                  {term}
                </span>
              </p>
            </SimpleListItem>
          )
        })}
      </SimpleList>
    </section>
  )
}
